import styled from 'styled-components';

const Wrapper = styled.div`
  input {
    width: 100%
    box-sizing: border-box;
    height: 48px;
    border: 1px solid #cecece;
    border-top: none;
    border-right: none;
    outline: none;
    padding: 1rem;
    font-size: 16px;
    background: transparent;
    
    &::placeholder {
      font-style: italic;
      opacity: 1;
      color: #7C7C7C;
    }
  }
`;

export { Wrapper };



// WEBPACK FOOTER //
// ./src/components/Input/style.js